<div class="main-page">

  <app-header></app-header>
  <div class="container">
    <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader>

    <div class="advertisement">
      <div class="innerPage advertisement-inner">
        <div class="advertisement-text">
          <span class="nav-divnk">My Business Banner</span>
        </div>
        <div class="content-part">
          <img src="assets/logo-5.png">
        </div>
        <div class="col-12 col-md-12 col-lg-12 col-xs-12 col-sm-12">
          <div class=" drop-dash" style="min-height: 500px">
            <div class=" display margin-b">
              <div class="tabButton mRight header-style cursor" [ngClass]="{ active: activeTab === 'create' }"
                (click)="getScrollTo('create')" id="create">
                Choose a Banner Plan
              </div>
              <div class="tabButton mLeft header-style cursor" [ngClass]="{ active: activeTab === 'manage' }"
                (click)="getScrollTo('manage')" id="manage">
                Manage My Banner
              </div>

            </div>
            <div *ngIf="activeTab == 'create'" class="position-relative">
              <div class="">
                <div *ngIf="subscription && subscription?.length > 0 && subscription[0]?.amount == 0 || !subscription?.length" class="row plan-card" style="margin-bottom:50px; display: flex; justify-content: space-around; color: red;">To create a front page Business Banner, <br> a paid subscription is necessary.</div>
                <div class="row">

                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div class="plan-card">
                            <div>
                                <h3 class="fs-title">My Banner Plans</h3>
                                <div class="myTable">
                                    <table >
                                        <tr>
                                            <th>No.</th>
                                            <th>Subscripition</th>
                                            <th>Status</th>
                                            <th>Valid Till</th>
                                            <th>Total / Monthly</th>
                                            <th></th>
                                        </tr>
                                        <tr>
                                        <tr *ngFor="let plan of myBannerPlans; let index = index">
                                            <td>{{index+1}}</td>
                                            <td>{{ plan?.caption ? plan?.caption : 'Base Plan'}}</td>
                                            <td> {{plan?.isActive ? "Active" : "Inactive"}} </td>
                                            <td>{{plan?.validTill | date}}</td>
                                            <td><span *ngIf="plan?.discount == 0">${{plan?.amount}}</span> <p  style="padding-top:11px !important" *ngIf="plan?.discount" ><s>${{plan?.amount}}</s> <span> ${{plan.amount * plan?.discount / 100 }} ({{plan?.discount}}% off)</span></p></td>
                                            <td *ngIf="plan?.isActive">  <button class="btn btn-danger" (click)="cancelSubscription(plan?._id)" type="button">Cancel Subscription</button> </td>
                                            <td *ngIf="!plan?.isActive">  <button class="btn btn-danger" (click)="reNewPlan(plan?.planId)" type="button">Renew Subscription</button> </td>
                                        </tr>
                                    </table>
                                    <p style="text-align: center; color: red;">* Banner plans renew monthly until canceled</p>
                                    <ng-container *ngIf="myBannerPlans?.length === 0">
                                        <p class="w-100 text-center my-4">
                                            No Plans Found
                                        </p>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">

                    <div class="col-md-12 col-md-offset-3">

                        <form id="msform">
                            <fieldset>
                                <h2 class="fs-title">Choose Your Banner Plan</h2>
                                <span *ngIf="isDiscount == 'true'" style="margin-top:-10px; background-color: #ffdb4d;">
                                    <small><b>Your plan entitles you to a 50% discount on Business Banner or ads. Create one today and save!</b></small>
                                </span>
                                <div style="min-height: 250px; margin-top: 1em">
                                    <h5 style="float:left;margin-left:20px;margin-bottom:0px;">Choose Category</h5>
                                    <div class="plan-name-area">
                                        <div class="card">
                                            <div class="myTable">
                                                <table>
                                                    <tr>
                                                        <th>Choose Visibilty</th>
                                                        <th>Total</th>
                                                    </tr>
                                                    <tr>
                                                    <tr *ngFor="let plan of allPlans; let index = index">
                                                        <td class="d-flex align-items-center">
                                                            <input
                                                            [disabled]="subscription && subscription?.length > 0 && subscription[0]?.amount == 0 || !subscription?.length" [checked]="plan?.price == bannerPlanType[0]?.amount"
                                                                class="mr-2 radio-btn" type="radio" [id]="plan._id"
                                                                name="bannerPlan"
                                                                (change)="changeBannerPlans(plan, 'banner')"
                                                                id="test@4521" />
                                                            <label class="mb-0" [for]="plan._id">{{ plan?.caption =='Regional'? 'Local/Regional': plan?.caption
                                                                }}</label>

                                                        </td>
                                                        <td>${{ plan?.visibiltyPrice }} /
                                                            <span>{{convertSubscripitonType(plan?.days)}}</span>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                                <!-- <h2 class="fs-title">Choose Banner Size Plans</h2> -->

                                <div style="min-height: 250px; margin-top: 1em">
                                    <div class="plan-name-area">
                                        <div class="card">

                                            <div class="myTable">
                                                <table>
                                                    <tr>
                                                        <th>Choose Size</th>
                                                        <th>Total</th>
                                                    </tr>
                                                    <tr>
                                                    <tr *ngFor="let plan of bannerSizePlans; let index = index">
                                                        <td class="d-flex align-items-center">
                                                            <input
                                                            [disabled]="subscription && subscription?.length > 0 && subscription[0]?.amount == 0 || !subscription?.length"
                                                                [checked]="plan?.bannerSize == checkBannerSize"
                                                                myBannerPlans       class="mr-2 radio-btn" type="radio"
                                                                name="bannerSizePlan"
                                                                [checked]="plan.bannerSize === selectedBannerSize"
                                                                (change)="changeBannerPlans(plan, 'size')"
                                                                [id]="plan._id" />
                                                            <label class="mb-0" [for]="plan._id">{{ plan?.bannerSize
                                                                }}</label>
                                                        </td>
                                                        <td>${{ plan?.bannerSizePrice }}/
                                                            <span>{{convertSubscripitonType(plan?.days)}}</span>
                                                        </td>
                                                    </tr>

                                                </table>
                                                <div class="row mTop15" *ngIf="total">
                                                    <div class="col-lg-3 col-md-3 col-sm-3"></div>
                                                    <div class="col-lg-4 col-md-4 col-sm-4">
                                                      <button (click)="downloadTemplate(bannerObject)" class="downLoad">Download Size Template</button>
                                                    </div>
                                                    <div class="col-lg-4 col-md-4 col-sm-4" >Monthly Total ${{total > 0 ? total:0}}</div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="mt-2" *ngIf="!isSubscribedToBannerPlan() && !isSubscribedToBannerSizePlan()">
                                   <p>You have already subscribed to the Banner Plan</p>
                                </div> -->
                                <button  (click)="next('banner')" type="button"
                                    name="next" class="next action-button btn-success">
                                   Next
                                </button>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>

            </div>
            <div *ngIf="activeTab == 'manage'" class="position-relative manageSection">

              <p class="pRight w-100 text-right"><i class="fa fa-plus-circle create-ads" (click)="createAds(content)" aria-hidden="true"
                title="Create Banner Ad"></i></p>
                <div class="plan-card">
                <div class="table-container">
                  <table class="myTable table mTop" style="background-color: white;">
                    <thead>
                      <tr>
                        <th>Banner Image</th>
                        <th>Plan type</th>
                        <th>Location</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let banner of bannerAds">
                        <!-- <td style="text-align: left;">{{advertisement.address.googleAddress}}</td> -->
                        <td class="image" (click)="redirectImage(banner.image)"><img  [src]="checkImage(banner.image)"></td>
                        <td style="text-align: center;" class="fit-text">{{banner.offerLocation}}, <br>{{banner.offerBannerSize}}</td>
                        <td  class="fit-text"> <span *ngIf="banner?.address?.city">City: {{banner.address.city}}</span><br>
                          <span *ngIf="banner?.address?.state">State: {{banner.address.state}}</span><br>
                          <span *ngIf="banner?.address?.country">Country: {{banner.address.country}}</span><br>
                          <span *ngIf="banner?.address?.postalCode">Postal Code: {{banner.address.postalCode}}</span>
                        </td>

                        <td>{{banner.startDate | date:'MMM d, y'}}</td>
                        <td>{{ banner.endDate | date:'MMM d, y'}}</td>
                        <td (click)="edit(banner)"><i class="fa fa-edit" aria-hidden="true"></i></td>
                        <td (click)="delete(banner._id)"><i class="fa fa-trash" aria-hidden="true"></i></td>
                      </tr>
                    </tbody>

                  </table>
                  <ng-container *ngIf="bannerAds?.length === 0">
                    <p class="w-100 text-center my-4">
                        No Banner Found
                    </p>
                </ng-container>
                </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>






</div>



<ng-template #content let-modal class="banner-modal">

  <button type="button" class="btnn btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">X</button>

  <div class="modal-body modal-body1">
    <form>
      <div class="mb-3 d-flex flex-wrap text-center justify-content-center">
        <h3 class="w-100 ">Banner Plan Required</h3>
        <h6 class="w-100 mt-2">Would you like to review the banner plans?</h6>
        <p class="w-100 mt-2" style="display: contents;">
          <button (click)="goToSubscribe()" class=" btn-primary">Yes</button>
          <button (click)="goToDashboard()" style="margin-left: 10px ;" class=" btn-danger">Cancel</button>
        </p>
      </div>
    </form>
  </div>
</ng-template>
